var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 780,
    height: 597,
    viewBox: "0 0 780 597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -818.984,
    y1: 469.586,
    x2: -676.906,
    y2: 222.318,
    gradientTransform: "translate(823)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#fff",
    stopOpacity: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#fff",
    stopOpacity: 0.403
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#fff",
    stopOpacity: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#fff",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#fff",
    stopOpacity: 0.934
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#fff",
    stopOpacity: 0.983
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -222.557,
    y1: -37.609,
    x2: -125.095,
    y2: 391.833,
    gradientTransform: "translate(823)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#fff",
    stopOpacity: 0.983
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#fff",
    stopOpacity: 0.934
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#fff",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#fff",
    stopOpacity: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#fff",
    stopOpacity: 0.403
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fff",
    stopOpacity: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.3,324.937C5.346,392.46.319,458.585.116,461.368a35.671,35.671,0,0,0,71.152,5.2c4.2-57.413,33.719-220.89,111.751-225.054V170.094C134.54,171.238,68.215,199.05,27.3,324.937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.329,207.514c-25.016-25.255-56.222-38.185-90.2-37.423l-.114,0v71.419c.578-.031,1.15-.083,1.734-.1,14.568-.342,26.543,4.851,37.888,16.3C270.464,306,288.363,448.265,284.76,560.014a35.669,35.669,0,0,0,34.5,36.8c.392.013.781.019,1.171.019a35.67,35.67,0,0,0,35.631-34.522C357.482,518.444,360.145,295.161,273.329,207.514Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.692,
    cy: 463.966,
    r: 35.672
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M780,425.3c-3.15-36.989-12.041-116.456-34.616-196.315C692.874,43.244,606.316.873,539.578.094V71.478c72.117,1.9,114.158,96.012,136.879,175.947,20.863,73.408,29.34,148.627,32.36,183.241"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530,.262c-10.033.4-70.582,5.93-129.185,80.781C327.173,175.1,288.122,336.455,284.745,560.626a35.672,35.672,0,0,0,35.13,36.205c.185,0,.365,0,.548,0A35.674,35.674,0,0,0,356.08,561.7c3.78-250.831,53.85-371.773,95.187-429.063C491.9,76.333,530,71.814,533,71.543l.214-.009c1.4-.068,2.776-.1,4.149-.1.743,0,1.478.026,2.215.045V.094Q534.715.037,530,.262Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 744.299,
    cy: 427.939,
    r: 35.672
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.0bbe9ea50e7effbb62f3bd9e3c043fa3.svg";
export { ForwardRef as ReactComponent };